<template>
  <div
    class="tips"
    :style="`display: ${isShow ? 'block' : 'none'}`"
  >
    <p>{{ state | showMsg }}</p>
  </div>
</template>

<script>
export default {
  filters: {
    showMsg(state) {
      const DISABLE = 'disable';
      const NORMAL = 'normal';
      const DOWNLOAD = 'download';
      const SSO = 'sso';
      const normal = '需要再次登陆';
      const disable = '已经停用';
      const download = '需要下载';
      const sso = '不用再次登陆';
      let msg = '错误的消息';
      switch (state) {
        case DISABLE:
          msg = disable;
          break;
        case NORMAL:
          msg = normal;
          break;
        case DOWNLOAD:
          msg = download;
          break;
        case SSO:
          msg = sso;
          break;
        default:
          break;
      }
      return msg;
    },
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      default: '默认消息',
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  position: absolute;
  bottom: 60px;
  width: 100%;
  min-width: 120px;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  background-color:rgba(123,139,198,.3);
  p {
    line-height: 40px;
    color: rgba(0,0,0,.7);
  }
}
</style>
